<template>
  <div class="flex flex-col w-4/5">
    <div v-for="(step, index) in steps" :key="index" class="relative">
      <div 
        class="absolute left-0 top-0 rounded-full w-6 h-6 
         text-sm font-semibold  flex items-center justify-center"
        :class="{
          'bg-accent-sky-60 text-white': step.status === 'active',
          'bg-white text-text-secondary': step.status === 'pending',
          'border border-border-default': step.status === 'pending',
          'dark:bg-black dark:text-dark-secondary': step.status === 'pending',
          'dark:border-border-disabled-dark': step.status === 'pending',
          'bg-success-green text-white': step.status === 'completed',
        }"
      >
        <div v-if="step.status === 'pending' || step.status === 'active'">
          {{ index + 1 }}
        </div>
        <font-awesome-icon
        v-if="step.status === 'completed'"
          icon="fa-solid fa-check"
          class="text-xs text-white"
        />
      </div>
      <h4 class="text-text-primary dark:text-text-primary-dark font-semibold ml-14 mb-2">
        {{ step.name }}
      </h4>
      <div 
        class="border-l-2 ml-3 pl-[43px] mb-2 py-5"
        :class="{
          'border-0!': index === steps.length - 1,
          'border-success-green': step.status === 'completed',
          'border-dark-secondary': step.status === 'pending',          
        }"
      >
        <slot :name="index" ></slot>
      </div>
    </div>
    <slot name="footer"></slot>
  </div>
</template>

<script setup>
const props = defineProps({
  steps: Array
})

</script>